import InputField from "../../components/Auth/InputField";
import useTranslator from "../../hooks/useTranslator";
import { PhoneInput } from "react-international-phone";
import styles from "./BasicInfoModal.module.css";

const LLBasicInfo = ({
  title,
  subtitle,
  userLogin,
  onChangeHandler,
  setUserLogin,
  submitHandler,
  setCurrentScreen,
}) => {
  const { _t } = useTranslator();
  return (
    <>
      <form
        onSubmit={submitHandler}
        className="formInformation passwordFormInfo"
      >
        <button
          type="button"
          onClick={() => setCurrentScreen?.("signup")}
          className={styles.backButton}
        >
          <span aria-hidden="true">&#8249;</span>
          {_t("back")}
        </button>
        <h2>{title}</h2>
        <p>{subtitle}</p>
        <div className="d-flex create-account-input">
          <InputField
            name={"fname_companyName"}
            isHalf={true}
            value={userLogin?.fname_companyName ?? ""}
            label={"firstName"}
            onChange={onChangeHandler}
            onBeforeInput={(e) => {
              const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
              if (!isValidChar) e.preventDefault();
            }}
          />
          <InputField
            name={"lname"}
            isHalf={true}
            value={userLogin?.lname ?? ""}
            label={"lastName"}
            onChange={onChangeHandler}
            onBeforeInput={(e) => {
              const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
              if (!isValidChar) e.preventDefault();
            }}
          />
        </div>
        <div className="forminput customInput">
          <h6 className="modal-label mb-0">{_t("phoneNumber")}</h6>
          <PhoneInput
            className="phone_input_info"
            international
            defaultCountry={"es"}
            value={userLogin?.phone}
            inputProps={{
              required: true,
            }}
            onChange={(e) =>
              setUserLogin((prev) => ({
                ...prev,
                phone: e?.replace("+", "") || "",
              }))
            }
          />
        </div>
        <button type="submit" className="btnNext basicInfoButton greenHover">
          {_t("submit")}
        </button>
      </form>
    </>
  );
};
export default LLBasicInfo;
